import angular from 'angular';
import {
  bcpDataService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-assessment-document-dialog.controller';
import template from './edit-assessment-document-dialog.html';
import bcpDocumentAttachmentNameMessagesTpl from './messages/bcp-document-attachment.name.messages.html';
import bcpDocumentAttachmentTypeMessagesTpl from './messages/bcp-document-attachment.type.messages.html';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

class dialogService {
  getOptions($event, {
    assessment,
    document,
  }) {
    return {
      controller,
      controllerAs: 'editAssessmentDocumentDialogVM',
      locals: {
        assessment,
        document,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editAssessmentDocumentDialog', [
  alerts,
  bcpDataService,
  ngFileUpload,
  ssDialogService,
])
  .service('bcpEditAssessmentDocumentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('bcp-document-attachment.name.messages.html', bcpDocumentAttachmentNameMessagesTpl);
    $templateCache.put('bcp-document-attachment.type.messages.html', bcpDocumentAttachmentTypeMessagesTpl);
  })
  .name;
